import styled from 'styled-components';

import { ModalHeading } from 'components/modal';

export const Header = styled(ModalHeading)`
  margin-block-end: 0.5rem;
`;
